﻿
import $ from 'jquery';
export class RequestVerificationToken {
  private static get selector(): string { return '#page-anti-forgery-token > input[name="__RequestVerificationToken"]'; }
  private static get key(): string { return '__RequestVerificationToken'; }
  private _value: string;
  constructor() {
    this._value = $(RequestVerificationToken.selector).val() as string;
  }

  public get key() {
    return RequestVerificationToken.key;
  }

  public get value() {
    return this._value;
  }
}

export default RequestVerificationToken;